/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{fillOffset as t}from"./fill.js";function n(n){const o=[0];return t(o,n.length-1),o}export{n as defaultOffset};
//# sourceMappingURL=default.js.map
